/* eslint-disable @typescript-eslint/camelcase */

import React from "react";
import {
    ProductDescriptionSerializer,
    ProductSizesSerializer,
    ProductMoreDescriptionsSerializer,
} from "web/types/serializers";
import PriceRange from "web/react/components/buybuybuy-area/price-range/price-range";
import SizeGuide from "web/react/components/buybuybuy-area/size-guide/size-guide";
import BuyOptions from "web/react/components/buybuybuy-area/buy-options/buy-options";
import { AffiliateOptionsProps } from "web/react/components/buybuybuy-area/affiliate-options/affiliate-options";
import ProductHeader, {
    ProductHeaderProps,
} from "web/react/components/buybuybuy-area/product-header/product-header";
import ProductDescription from "web/react/components/buybuybuy-area/product-description/product-description";

interface BuyAreaProps {
    header: ProductHeaderProps;
    csrfToken: string;
    buyAreaOptions: {
        min_and_max_price_are_the_same: boolean;
        has_regular_price: boolean;
        multiple_stores: boolean;
        regular_price_with_currency_symbol: string;
        minimum_price_with_currency_symbol: string;
        maximum_price_with_currency_symbol: string;
        size_guide_link: string;
        form_action: string;
        return_url: string;
        available_sizes: any[];
        sizes: any[];
        stores_tip: string;
        country: string;
        buybuybuy_options: {
            with_search: boolean;
            icon_options: any[];
            affiliate_options: AffiliateOptionsProps;
            product_id: string;
            is_saved_for_later: "true" | "false";
        };
    };
    productDescription: ProductDescriptionSerializer & { product_sizes: ProductSizesSerializer };
    productMoreDescriptions: ProductMoreDescriptionsSerializer;
    isOverlay?: boolean;
}

function BuyArea({
    header,
    csrfToken,
    buyAreaOptions: {
        min_and_max_price_are_the_same,
        has_regular_price,
        multiple_stores,
        regular_price_with_currency_symbol,
        minimum_price_with_currency_symbol,
        maximum_price_with_currency_symbol,
        size_guide_link,
        form_action,
        return_url,
        available_sizes,
        sizes,
        stores_tip,
        country,
        buybuybuy_options: {
            with_search,
            icon_options,
            affiliate_options,
            product_id,
            is_saved_for_later,
        },
    },
    productDescription,
    productMoreDescriptions,
    isOverlay,
}: BuyAreaProps): React.ReactElement {
    return (
        <div className="buybuybuy-area">
            <ProductHeader {...header} />
            <PriceRange
                minMaxSame={min_and_max_price_are_the_same}
                hasRegularPrice={has_regular_price}
                multipleStores={multiple_stores}
                regularPriceWithCurrencySymbol={regular_price_with_currency_symbol}
                minimumPriceWithCurrencySymbol={minimum_price_with_currency_symbol}
                maximumPriceWithCurrencySymbol={maximum_price_with_currency_symbol}
            />
            <SizeGuide sizeGuideLink={size_guide_link} />
            <BuyOptions
                withSearch={with_search}
                isOverlay={isOverlay}
                iconOptions={icon_options}
                affiliateOptions={affiliate_options}
                productId={product_id}
                isSavedForLater={is_saved_for_later}
                sizeOptionsForm={{
                    csrfToken: csrfToken,
                    action: form_action,
                    country: country,
                    returnUrl: return_url,
                    availableSizes: available_sizes,
                    sizes: sizes,
                    storesTip: stores_tip,
                }}
            />
            <ProductDescription
                {...productDescription}
                more_descriptions={productMoreDescriptions}
            />
        </div>
    );
}

export default BuyArea;
